<!-- PIEZEO PREVIEW MODAL -->
<div class="overlay" *ngIf="modal_type() == 'pt_preview'" (click)="closePiezeoImgModalBox()">
  <div class="piezeo-modal" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="piezeo-modal-header">
      <h2 class="piezeo-modal-title">Piezeo Details</h2>
      <button class="header-close-btn" (click)="closePiezeoImgModalBox()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="piezeo-modal-body">
      <div class="piezeo-content">
        <!-- Title Section -->
        <div class="piezeo-title-section">
          <h3 class="piezeo-name">{{ powertrainName() }}</h3>
          <div class="piezeo-actions">
            <button class="action-btn" (click)="editPiezo()" matTooltip="Edit Piezeo">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </div>

        <!-- Image Container with Sensors -->
        <div class="image-wrapper">
          <div class="image-container" #imageContainer>
            <img [src]="peizeoImg()" class="piezeo-image" #powertrainImage (load)="onImageLoad()"
              alt="Powertrain Image" />

            <!-- Sensors positioned relative to image -->
            <div class="sensor-marker" *ngFor="let sensor of sensors()" [ngStyle]="{
                top: sensor.yPercentage + '%',
                left: sensor.xPercentage + '%'
              }" [attr.data-status]="getSensorStatus(sensor)" (click)="onSensorClick(sensor)"
              [matTooltip]="showTooltip(sensor)" matTooltipPosition="above">
              <div class="sensor-content">
                <span class="sensor-label">{{ sensor.sensorDNames }}</span>
                <div class="sensor-indicator">
                  <mat-icon class="sensor-icon" *ngIf="sensor.asset_status == 1 || sensor.asset_status == 0">
                    wifi
                  </mat-icon>
                  <mat-icon class="sensor-icon offline" *ngIf="sensor.asset_status == 2">
                    wifi_off
                  </mat-icon>
                </div>
              </div>
              <div class="sensor-pulse" *ngIf="sensor.color == '#ff2a1b'"></div>
            </div>
          </div>
        </div>

        <!-- Legend -->
        <div class="sensor-legend">
          <div class="legend-item">
            <span class="legend-dot critical"></span>
            <span class="legend-text">Critical</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot warning"></span>
            <span class="legend-text">Warning</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot normal"></span>
            <span class="legend-text">Normal</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="piezeo-modal-footer">
      <button mat-raised-button color="primary" (click)="closePiezeoImgModalBox()">
        Close
      </button>
    </div>
  </div>
</div>

<!-- PIEZEO PREVIEW MODAL -->
<div class="overlay" *ngIf="modal_type() == 'pt_preview'" (click)="closePiezeoImgModalBox()">
  <div class="piezeo-modal" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="piezeo-modal-header">
      <h2 class="piezeo-modal-title">Piezeo Details</h2>
      <button class="header-close-btn" (click)="closePiezeoImgModalBox()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="piezeo-modal-body">
      <div class="piezeo-content">
        <!-- Title Section -->
        <div class="piezeo-title-section">
          <h3 class="piezeo-name">{{ powertrainName() }}</h3>
          <div class="piezeo-actions">
            <button class="action-btn" (click)="editPiezo()" matTooltip="Edit Piezeo">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </div>

        <!-- Image Container with Sensors -->
        <div class="image-wrapper">
          <div class="image-container" #imageContainer>
            <img [src]="peizeoImg()" class="piezeo-image" #powertrainImage (load)="onImageLoad()"
              alt="Powertrain Image" />

            <!-- Sensors positioned relative to image -->
            <div class="sensor-marker" *ngFor="let sensor of sensors()" [ngStyle]="{
                top: sensor.yPercentage + '%',
                left: sensor.xPercentage + '%'
              }" [attr.data-status]="getSensorStatus(sensor)" (click)="onSensorClick(sensor)"
              [matTooltip]="showTooltip(sensor)" matTooltipPosition="above">
              <div class="sensor-content">
                <span class="sensor-label">{{ sensor.sensorDNames }}</span>
                <div class="sensor-indicator">
                  <mat-icon class="sensor-icon" *ngIf="sensor.asset_status == 1 || sensor.asset_status == 0">
                    wifi
                  </mat-icon>
                  <mat-icon class="sensor-icon offline" *ngIf="sensor.asset_status == 2">
                    wifi_off
                  </mat-icon>
                </div>
              </div>
              <div class="sensor-pulse" *ngIf="sensor.color == '#ff2a1b'"></div>
            </div>
          </div>
        </div>

        <!-- Legend -->
        <div class="sensor-legend">
          <div class="legend-item">
            <span class="legend-dot critical"></span>
            <span class="legend-text">Critical</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot warning"></span>
            <span class="legend-text">Warning</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot normal"></span>
            <span class="legend-text">Normal</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="piezeo-modal-footer">
      <button mat-raised-button color="primary" (click)="closePiezeoImgModalBox()">
        Close
      </button>
    </div>
  </div>
</div>

<!-- GATEWAY CONFIGURATION MODAL -->
<div class="overlay" *ngIf="modal_type()=='add_gateway'" (click)="closeGatewayModal()">
  <div class="gateway-modal" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="gateway-modal-header">
      <h2 class="gateway-modal-title">Gateway Configuration</h2>
      <button class="header-close-btn" (click)="closeGatewayModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="gateway-modal-body">
      <form [formGroup]="gatewayConfigForm" class="gateway-config-form">
        <div class="form-section-title">Gateway Settings</div>
        <!-- GATEWAY CONFIG FORM ========== ROW 1 -->
        <div class="d-flex gap-2">
          @if (gateway_loader && gatewayTypes.length==0) {
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Gateway Type</mat-label>
            <mat-select formControlName="gatewayType" required
              (selectionChange)="handleGatewayDeviceChange($event.value,'')">
              <mat-option [value]="">
                Loading Gateway Types...
              </mat-option>
            </mat-select>
          </mat-form-field>
          }@else {
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Gateway Type</mat-label>
            <mat-select formControlName="gatewayType" required
              (selectionChange)="handleGatewayDeviceChange($event.value,'')">
              <mat-option *ngFor="let type of gatewayTypes" [value]="type.id">
                {{ type.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="gatewayConfigForm.get('gatewayType')?.hasError('required') && gatewayConfigForm.get('gatewayType')?.touched">
              Gateway Type is required.
            </mat-error>
          </mat-form-field>
          }
          @if(gateway_loader && gatewayAddresses.length==0) {
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Gateway Address</mat-label>
            <mat-select formControlName="gatewayAddress" required>
              <mat-option [value]="">
                Loading Gateway Addresses...
              </mat-option>
            </mat-select>
          </mat-form-field>
          }@else {
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Gateway Address</mat-label>
            <mat-select formControlName="gatewayAddress" required>
              <mat-option *ngFor="let address of gatewayAddresses" [value]="address">
                {{ address.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="gatewayConfigForm.get('gatewayAddress')?.hasError('required') && gatewayConfigForm.get('gatewayAddress')?.touched">
              Gateway Address is required.
            </mat-error>
          </mat-form-field>
          }
        </div>

        <!-- GATEWAY CONFIG FORM ========== ROW 2 -->
        <div class="d-flex gap-2">
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Summary File Refresh Rate (seconds)</mat-label>
            <input matInput type="number" formControlName="summaryFileRefreshRate" required min="1">
            <mat-error
              *ngIf="gatewayConfigForm.get('summaryFileRefreshRate')?.hasError('required') && gatewayConfigForm.get('summaryFileRefreshRate')?.touched">
              Summary File Refresh Rate is required.
            </mat-error>
            <mat-error
              *ngIf="gatewayConfigForm.get('summaryFileRefreshRate')?.hasError('min') && gatewayConfigForm.get('summaryFileRefreshRate')?.touched">
              Value must be at least 1.
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Full Refresh File Rate (seconds)</mat-label>
            <input matInput type="number" formControlName="fullRefreshFileRate" required min="1">
          </mat-form-field>
        </div>

        <!-- GATEWAY CONFIG FORM ========== ROW 3 -->
        <div class="d-flex gap-2">
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Anomaly Analysis (seconds)*</mat-label>
            <input matInput type="number" formControlName="anomalyAnalysisTime" required min="1">
            <mat-error
              *ngIf="gatewayConfigForm.get('anomalyAnalysisTime')?.hasError('required') && gatewayConfigForm.get('anomalyAnalysisTime')?.touched">
              Summary File Refresh Rate is required.
            </mat-error>
            <mat-error
              *ngIf="gatewayConfigForm.get('anomalyAnalysisTime')?.hasError('min') && gatewayConfigForm.get('anomalyAnalysisTime')?.touched">
              Value must be at least 1.
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Anomaly Counter*</mat-label>
            <input matInput type="number" formControlName="anomalyCounter" required min="1">
            <mat-error
              *ngIf="gatewayConfigForm.get('anomalyCounter')?.hasError('required') && gatewayConfigForm.get('anomalyCounter')?.touched">
              Summary File Refresh Rate is required.
            </mat-error>
            <mat-error
              *ngIf="gatewayConfigForm.get('anomalyCounter')?.hasError('min') && gatewayConfigForm.get('anomalyCounter')?.touched">
              Value must be at least 1.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- GATEWAY CONFIG FORM ========== ROW 4 -->
        <div class="d-flex gap-2">
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Scan Rate (seconds)*</mat-label>
            <input matInput type="number" formControlName="scanRate" required min="15" max="60">
            <mat-error
              *ngIf="gatewayConfigForm.get('scanRate')?.hasError('required') && gatewayConfigForm.get('scanRate')?.touched">
              Summary File Refresh Rate is required.
            </mat-error>
            <mat-error
              *ngIf="gatewayConfigForm.get('scanRate')?.hasError('min') && gatewayConfigForm.get('scanRate')?.touched">
              Value must be at least 1.
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>ODR*</mat-label>
            <mat-select formControlName="odr_value" required>
              <mat-option *ngFor="let odr of odr_options" [value]="odr.value">
                {{ odr.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="gatewayConfigForm.get('odr_value')?.hasError('required') && gatewayConfigForm.get('odr_value')?.touched">
              ODR value is required.
            </mat-error>
          </mat-form-field>
        </div>
        <!-- GATEWAY CONFIG FORM ========== ROW 5 -->
        <div class="d-flex gap-2">

          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Asset On/Off Threshold Status*</mat-label>
            <input matInput type="number" formControlName="asset_threshold_status" required min="0" max="127">
            <mat-error
              *ngIf="gatewayConfigForm.get('asset_threshold_status')?.hasError('required') && gatewayConfigForm.get('asset_threshold_status')?.touched">
              Summary File Refresh Rate is required.
            </mat-error>
            <mat-error
              *ngIf="gatewayConfigForm.get('asset_threshold_status')?.hasError('min') && gatewayConfigForm.get('asset_threshold_status')?.touched">
              Value must be at least 1.
            </mat-error>
          </mat-form-field>

        </div>

        <!-- ==========ERRORS================= -->
        <mat-error
          *ngIf="gatewayConfigForm.get('fullRefreshFileRate')?.hasError('required') && gatewayConfigForm.get('fullRefreshFileRate')?.touched">
          Full Refresh File Rate is required.
        </mat-error>
        <mat-error
          *ngIf="gatewayConfigForm.get('fullRefreshFileRate')?.hasError('invalidRange') && gatewayConfigForm.get('fullRefreshFileRate')?.touched">
          Full Refresh File Rate must be greater than summary File Rate.
        </mat-error>
        <mat-error
          *ngIf="gatewayConfigForm.get('fullRefreshFileRate')?.hasError('valuesEqual') && gatewayConfigForm.get('fullRefreshFileRate')?.touched">
          Full Refresh File Rate must be greater than summary File Rate.
        </mat-error>
        <mat-error
          *ngIf="gatewayConfigForm.get('fullRefreshFileRate')?.hasError('min') && gatewayConfigForm.get('fullRefreshFileRate')?.touched">
          Value must be at least 1.
        </mat-error>
      </form>
    </div>

    <!-- Footer -->
    <div class="gateway-modal-footer">
      <button mat-flat-button color="warn" (click)="clearGatewayConfig()" type="button">Clear</button>
      <button mat-flat-button color="primary" [disabled]="gatewayConfigForm.invalid" (click)="saveGatewayConfig()"
        type="submit">Save Configuration</button>
    </div>
  </div>
</div>


<!-- ========================================================================================================================== -->
<!-- ========================================================================================================================== -->
<!-- ============================================ EDIT GATEWAY CONFIGURATION MODAL ============================================ -->
<!-- ========================================================================================================================== -->
<!-- ========================================================================================================================== -->
<div class="overlay" *ngIf="modal_type()=='edit_gateway'" (click)="closeGatewayModal()">
  <div class="gateway-modal" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="gateway-modal-header">
      <h2 class="gateway-modal-title">Gateway Configuration</h2>
      <button class="header-close-btn" (click)="closeGatewayModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="gateway-modal-body">
      <form [formGroup]="gatewayConfigForm" class="gateway-config-form">
        <div class="form-section-title">Gateway Settings</div>
        <!-- GATEWAY CONFIG FORM ========== ROW 1 -->
        <div class="d-flex gap-2">
          @if (gateway_loader && gatewayTypes.length==0) {
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Gateway Type</mat-label>
            <mat-select formControlName="gatewayType" required
              (selectionChange)="handleGatewayDeviceChange($event.value,'')">
              <mat-option [value]="">
                Loading Gateway Types...
              </mat-option>
            </mat-select>
          </mat-form-field>
          }@else {
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Gateway Type</mat-label>
            <mat-select formControlName="gatewayType" required
              (selectionChange)="handleGatewayDeviceChange($event.value,'')">
              <mat-option *ngFor="let type of gatewayTypes" [value]="type.id">
                {{ type.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="gatewayConfigForm.get('gatewayType')?.hasError('required') && gatewayConfigForm.get('gatewayType')?.touched">
              Gateway Type is required.
            </mat-error>
          </mat-form-field>
          }
          @if(gateway_loader && gatewayAddresses.length==0) {
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Gateway Address</mat-label>
            <mat-select formControlName="gatewayAddress" required>
              <mat-option [value]="">
                Loading Gateway Addresses...
              </mat-option>
            </mat-select>
          </mat-form-field>
          }@else {
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Gateway Address</mat-label>
            <mat-select formControlName="gatewayAddress" required>
              <mat-option *ngFor="let address of gatewayAddresses" [value]="address">
                {{ address.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="gatewayConfigForm.get('gatewayAddress')?.hasError('required') && gatewayConfigForm.get('gatewayAddress')?.touched">
              Gateway Address is required.
            </mat-error>
          </mat-form-field>
          }
        </div>

        <!-- GATEWAY CONFIG FORM ========== ROW 2 -->
        <div class="d-flex gap-2">
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Summary File Refresh Rate (seconds)</mat-label>
            <input matInput type="number" formControlName="summaryFileRefreshRate" required min="1">
            <mat-error
              *ngIf="gatewayConfigForm.get('summaryFileRefreshRate')?.hasError('required') && gatewayConfigForm.get('summaryFileRefreshRate')?.touched">
              Summary File Refresh Rate is required.
            </mat-error>
            <mat-error
              *ngIf="gatewayConfigForm.get('summaryFileRefreshRate')?.hasError('min') && gatewayConfigForm.get('summaryFileRefreshRate')?.touched">
              Value must be at least 1.
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Full Refresh File Rate (seconds)</mat-label>
            <input matInput type="number" formControlName="fullRefreshFileRate" required min="1">
          </mat-form-field>
        </div>

        <!-- GATEWAY CONFIG FORM ========== ROW 3 -->
        <div class="d-flex gap-2">
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Anomaly Analysis (seconds)*</mat-label>
            <input matInput type="number" formControlName="anomalyAnalysisTime" required min="1">
            <mat-error
              *ngIf="gatewayConfigForm.get('anomalyAnalysisTime')?.hasError('required') && gatewayConfigForm.get('anomalyAnalysisTime')?.touched">
              Summary File Refresh Rate is required.
            </mat-error>
            <mat-error
              *ngIf="gatewayConfigForm.get('anomalyAnalysisTime')?.hasError('min') && gatewayConfigForm.get('anomalyAnalysisTime')?.touched">
              Value must be at least 1.
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Anomaly Counter*</mat-label>
            <input matInput type="number" formControlName="anomalyCounter" required min="1">
            <mat-error
              *ngIf="gatewayConfigForm.get('anomalyCounter')?.hasError('required') && gatewayConfigForm.get('anomalyCounter')?.touched">
              Summary File Refresh Rate is required.
            </mat-error>
            <mat-error
              *ngIf="gatewayConfigForm.get('anomalyCounter')?.hasError('min') && gatewayConfigForm.get('anomalyCounter')?.touched">
              Value must be at least 1.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- GATEWAY CONFIG FORM ========== ROW 4 -->
        <div class="d-flex gap-2">
          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>Scan Rate (seconds)*</mat-label>
            <input matInput type="number" formControlName="scanRate" required min="15" max="60">
            <mat-error
              *ngIf="gatewayConfigForm.get('scanRate')?.hasError('required') && gatewayConfigForm.get('scanRate')?.touched">
              Summary File Refresh Rate is required.
            </mat-error>
            <mat-error
              *ngIf="gatewayConfigForm.get('scanRate')?.hasError('min') && gatewayConfigForm.get('scanRate')?.touched">
              Value must be at least 1.
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width-input">
            <mat-label>ODR*</mat-label>
            <mat-select formControlName="odr_value" required>
              <mat-option *ngFor="let odr of odr_options" [value]="odr.value">
                {{ odr.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="gatewayConfigForm.get('odr_value')?.hasError('required') && gatewayConfigForm.get('odr_value')?.touched">
              ODR value is required.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- ==========ERRORS================= -->
        <mat-error
          *ngIf="gatewayConfigForm.get('fullRefreshFileRate')?.hasError('required') && gatewayConfigForm.get('fullRefreshFileRate')?.touched">
          Full Refresh File Rate is required.
        </mat-error>
        <mat-error
          *ngIf="gatewayConfigForm.get('fullRefreshFileRate')?.hasError('invalidRange') && gatewayConfigForm.get('fullRefreshFileRate')?.touched">
          Full Refresh File Rate must be greater than summary File Rate.
        </mat-error>
        <mat-error
          *ngIf="gatewayConfigForm.get('fullRefreshFileRate')?.hasError('valuesEqual') && gatewayConfigForm.get('fullRefreshFileRate')?.touched">
          Full Refresh File Rate must be greater than summary File Rate.
        </mat-error>
        <mat-error
          *ngIf="gatewayConfigForm.get('fullRefreshFileRate')?.hasError('min') && gatewayConfigForm.get('fullRefreshFileRate')?.touched">
          Value must be at least 1.
        </mat-error>
      </form>
    </div>

    <!-- Footer -->
    <div class="gateway-modal-footer">
      <button mat-flat-button color="warn" (click)="clearGatewayConfig()" type="button">Clear</button>
      <button mat-flat-button color="primary" [disabled]="gatewayConfigForm.invalid" (click)="saveGatewayConfig()"
        type="submit">Save Configuration</button>
    </div>
  </div>
</div>



<!-- PIEZEO CONFIGURATION MODAL -->
<div class="overlay" *ngIf="modal_type()=='piezeo_config'" (click)="closePiezeoConfigModal()">
  <div class="piezeo-config-modal" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="piezeo-config-modal-header">
      <h2 class="piezeo-config-modal-title">Piezo Configuration</h2>
      <button class="header-close-btn" (click)="closePiezeoConfigModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="piezeo-config-modal-body">
      <form [formGroup]="piezeoConfigForm" class="piezeo-config-form">
        <div class="form-section-title">Piezo Configuration</div>

        <div class="current-sensor-container">
          <div class="sensor-info-box">
            <p class="current-sensor-info">
              Asset Marker: <strong>{{ current_sensor?.assetMarker || 'N/A' }}</strong>
            </p>
            <p class="current-sensor-info">
              Asset Type: <strong>{{ current_sensor?.assetType || 'N/A' }}</strong>
            </p>
            <p class="current-sensor-info">
              Asset Name: <strong>{{ current_sensor?.sensorMarker || 'N/A' }}</strong>
            </p>
          </div>
        </div>



        <mat-form-field appearance="outline" class="full-width-input" *ngIf="current_sensor.is_temperature_added==1">
          <mat-label>Select Temperature Channel</mat-label>
          <mat-select formControlName="temperature_channel" required
            (selectionChange)="updateAvailableChannels($event)">
            @if(current_sensor.configured && current_sensor.temperature_channel ){
            <mat-option *ngFor="let channel of [current_sensor.temperature_channel]"
              [value]="current_sensor.temperature_channel">
              {{ channel }}
            </mat-option>
            }
            @else {
            <mat-option *ngFor="let channel of channel_numbers" [value]="channel">
              {{ channel }}
            </mat-option>
            }
          </mat-select>
          <mat-error
            *ngIf="piezeoConfigForm.get('no_of_axis')?.hasError('required') && piezeoConfigForm.get('no_of_axis')?.touched">
            Number of Axis is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width-input">
          <mat-label>Select Number of Axis</mat-label>
          <mat-select formControlName="no_of_axis" required>
            <mat-option *ngFor="let type of [1,2,3]" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="piezeoConfigForm.get('no_of_axis')?.hasError('required') && piezeoConfigForm.get('no_of_axis')?.touched">
            Number of Axis is required.
          </mat-error>
        </mat-form-field>

        <div formGroupName="sensors_info" class="sensors-info-group">
          <div *ngFor="let axis of total_no_of_axis; let i = index" class="sensor-axis-group">
            <h4 class="axis-title">Sensor {{ i + 1 }}</h4>

            <!-- Axis Select -->
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Axis</mat-label>
              <mat-select [formControlName]="'sensor_' + (i + 1) + '_axis'">
                <mat-option value="" disabled>Select Axis</mat-option>
                <mat-option *ngFor="let opt of ['X', 'Y', 'Z']" [value]="opt">{{ opt }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Channel</mat-label>
              <mat-select [formControlName]="'sensor_' + (i + 1) + '_channel'"
                (selectionChange)="updateAvailableChannels($event)">
                <!-- Shown only if the current sensor is NOT configured -->
                <mat-option value="" *ngIf="!current_sensor.configured" disabled>
                  Select Channel
                </mat-option>

                <!-- Shown only if the current sensor IS configured -->
                <mat-option value="{{ current_sensor.sensors_info['sensor_' + (i + 1) + '_channel'] }}" disabled
                  *ngIf="current_sensor.configured">
                  {{ current_sensor.sensors_info['sensor_' + (i + 1) + '_channel'] }}
                </mat-option>

                @if (current_sensor.configured) {
                <mat-option *ngFor="let channel of [current_sensor.sensors_info['sensor_' + (i + 1) + '_channel']]"
                  [value]="channel">
                  {{ channel }}
                </mat-option>
                }@else {
                <!-- Available channels to pick from -->
                <mat-option *ngFor="let channel of channel_numbers" [value]="channel">
                  {{ channel }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>

          </div>

          <div
            *ngIf="piezeoConfigForm.get('sensors_info')?.errors?.duplicateAxis && piezeoConfigForm.get('sensors_info')?.touched"
            class="error-message">
            ❌ Two or more axes are the same!
          </div>
          <div
            *ngIf="piezeoConfigForm.get('sensors_info')?.errors?.duplicateChannel && piezeoConfigForm.get('sensors_info')?.touched"
            class="error-message">
            ❌ Two or more channels are the same!
          </div>

        </div>
      </form>
    </div>

    <!-- Footer -->
    <div class="piezeo-config-modal-footer">
      @if(current_sensor.configured){
      <button mat-flat-button color="warning" (click)="clearCurrentPiezoConfig()" [disabled]="piezeoConfigForm.invalid"
        type="submit">
        Clear Configuration
      </button>
      }
      <button mat-flat-button color="primary" (click)="saveCurrentPiezeoConfig()" [disabled]="piezeoConfigForm.invalid"
        type="submit">
        Save Configuration
      </button>
    </div>
  </div>
</div>

<!-- ===================================================================================== -->
<!-- ===================================================================================== -->
<!-- ========================= ASSOCIATE DEVICE TO GATEWAY MODAL ========================= -->
<!-- ===================================================================================== -->
<!-- ===================================================================================== -->
<div class="overlay" *ngIf="modal_type()=='associate_device_to_gateway'">
  <div class="gateway-modal">
    <!-- Header -->
    <div class="gateway-modal-header">
      <h2 class="gateway-modal-title">Associate Device to Gateway</h2>
      <button class="header-close-btn" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="gateway-modal-body">
      <!-- Gateway Details Card -->
      <div class="sensor-info-box gateway-card">
        <div class="gateway-header">Gateway Configuration</div>
        <div class="gateway-details">
          <div class="detail-item"><strong>Gateway Address:</strong> {{gateway_data().gatewayAddress}}</div>
          <div class="detail-item"><strong>Current Axis:</strong> {{gateway_data().curr_axis}}</div>
          <div class="detail-item"><strong>Max Axis:</strong> {{gateway_data().max_axis}}</div>
          <div class="detail-item"><strong>Devices Associated:</strong> {{gateway_data().device_associated}}</div>
        </div>
      </div>

      <!-- Sensors List -->
      <div class="sensors-info-group">
        <div class="sensor-info-box" *ngFor="let s of filtered_sensors">
          <div class="current-sensor-info"><strong>Master Type:</strong> {{s.assetType}}</div>
          <div class="current-sensor-info"><strong>Name:</strong> {{s.sensorDNames}}</div>
          <div class="current-sensor-info" *ngIf="s.curr_axis !== undefined">
            <strong>Current Axis:</strong> {{s.curr_axis}} / {{s.max_axis}}
          </div>
          <div class="current-sensor-info" *ngIf="s.device_associated !== undefined">
            <strong>Devices Associated:</strong> {{s.device_associated}}
          </div>
          @if (!s.associated) {
          <div class="piezeo-actions">
            <button class="action-btn" (click)="openAxisModal(s)">
              <mat-icon>add</mat-icon>
            </button>
          </div>
          }@else {
          <div class="piezeo-actions">
            <button class="action-btn" (click)="unassociateDevice(s)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          }
        </div>
      </div>
    </div>


    <!-- Footer -->
    <div class="gateway-modal-footer">
      <button mat-flat-button (click)="closeGatewayDeviceAssociationModal()">Close</button>
    </div>
  </div>
</div>

<!-- ===================================================================================== -->
<!-- ===================================================================================== -->
<!-- ========================= ADD NUMBER OF AXIS MODAL ================================== -->
<!-- ===================================================================================== -->
<!-- ===================================================================================== -->

<div class="overlay" *ngIf="open_axis_modal">
  <div class="gateway-modal">
    <!-- Header -->
    <div class="gateway-modal-header">
      <h2 class="gateway-modal-title">Add Number of Axis</h2>
      <button class="header-close-btn" (click)="cancelCurrentSensorAssociation()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="gateway-modal-body">
      <div class="sensor-axis-group">
        <mat-form-field appearance="outline" class="full-width-input">
          <mat-label>Select Number of Axis</mat-label>
          <mat-select [(ngModel)]="no_of_axis" id="axisSelect">
            <mat-option *ngFor="let i of [1,2,3]" [value]="i">{{i}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width-input">
          <mat-label>Temperature Associated* </mat-label>
          <mat-select [(ngModel)]="is_temperature_added" id="axisSelect">
            <mat-option [value]="1">Yes</mat-option>
            <mat-option [value]="0">No</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>


    <!-- Footer -->
    <div class="gateway-modal-footer">
      <button mat-flat-button class="mat-primary" (click)="saveCurrentSensorAxis()">Save</button>
      <button mat-flat-button (click)="cancelCurrentSensorAssociation()">Cancel</button>
    </div>
  </div>
</div>